import * as React from 'react';
import { CheckboxChipButton } from '@cian/ui-kit';
import { useEventCallback } from '@cian/react-utils';

interface ICheckboxButtonFilterProps {
  label: string;
  checked: boolean;
  onChange(checked: boolean): void;
  dataName?: string;
}

export const CheckboxButtonFilter: React.FC<ICheckboxButtonFilterProps> = ({ label, checked, onChange, dataName }) => {
  const handleChange = useEventCallback((_event: React.ChangeEvent<HTMLInputElement>, value: boolean) => {
    onChange(value);
  });

  return <CheckboxChipButton data-name={dataName} label={label} checked={checked} onChange={handleChange} size="XS" />;
};
